import { render } from "./CollectionNetworkBadge.vue?vue&type=template&id=555dadb2&scoped=true"
import script from "./CollectionNetworkBadge.vue?vue&type=script&lang=js"
export * from "./CollectionNetworkBadge.vue?vue&type=script&lang=js"

import "@/Common/Styles/networkBadge.scss?vue&type=style&index=0&id=555dadb2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555dadb2"]])

export default __exports__